//文献检索条件基础结构
export function getBasicSearchParam() {
  return {
    yearStart: null,
    yearEnd: null,
    sort: null,
    page: 1,
    size: 10,
    order: false,
    language: "",
    ags: false,
    aggsParams: {},
    conditions: [],
    types: [],
    agsCodes: ['Y', 'J', 'A','O', 'C', 'S', 'class_lhzxx'],
    //agsCodes: ['year', 'journalId', 'author','organ', 'classEdu', 'subject', 'class_lhzxx'], 
    timeStart: null,
    timeEnd: null,
    timeType: null,
    openSynonym: false,
    openForceTranslate: false,
  };
}

//期刊检索条件基础结构+
export function getBasicJournalSearchParam() {
  return {
    size: 10,
    content: '',
    type: '',
    page: 1,
    ags: false,
    aggsParams: {},
    isCore: '',
    initials: [],
    sort: null,
    order: false
  };
}

// export function getSearchParam(obj) {
//   var param = getBasicSearchParam();
//   if (obj.sort) {
//     param.sort=obj.sort;
//   }
//   return param;
// }